import type { NextPage } from 'next'
import { paths } from '@/constants/paths'
import { Seo } from '@/layout/Seo'
import { getGenericStaticPaths } from '@/utils/GetGenericStaticPaths'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { getBasePath } from '@/utils/sitemap/base'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { OurMissionView } from '@/views/OurMissionView'

interface AboutProps {
  locale: string
}

const Home: NextPage<AboutProps> = ({ locale }) => {
  const { t } = useTranslate('about')
  const url = `${getBasePath(locale)}`
  const title = t('angelStudiosOurMissionTitle', 'Our Mission | Angel Studios')
  const description = t('angelStudiosOurMissionDescription', 'We’re building a home for stories that amplify light.')
  return (
    <>
      <Seo
        canonical={url}
        description={description}
        openGraph={{ title, description, url }}
        path={paths.about.ourMission}
        title={title}
      />
      <OurMissionView />
    </>
  )
}

export const getStaticPaths = getGenericStaticPaths

export const getStaticProps = getStaticPropsErrorHandler<AboutProps>(
  { filePath: 'pages/[locale]/about/our-mission.tsx' },
  async ({ locale }) => {
    return {
      props: {
        locale,
        ...(await loadTranslations(locale, ['common', 'about', 'app-promo', 'account'])),
      },
    }
  },
)

export default Home
